/**
 * @desc timelinessDashboardBySku
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(body: defs.wms.TimelinessDashboardRequestDto, options?: any) {
  return updateResponse(
    http(URL + `/allocation/timelinessDashboardBySku`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
